export const getViewportMetaElement = () => {
  let viewportMetaElement = document.querySelector('meta[name="viewport"]');

  if (!viewportMetaElement) {
    viewportMetaElement = document.createElement('meta');
    viewportMetaElement.setAttribute('name', 'viewport');
    viewportMetaElement.setAttribute('content', 'width=device-width,user-scalable=0');
    document.head.appendChild(viewportMetaElement);
  }

  return viewportMetaElement;
};

export const forceDesktopView = () => {
  try {
    const viewportMetaElement = getViewportMetaElement();

    viewportMetaElement.setAttribute('content', `width=770,user-scalable=0,viewport-fit=cover,shrink-to-fit=yes`);
    setTimeout(() => window.dispatchEvent(new Event('resize')), 100);
  } catch (error) {
    // tslint:disable-next-line: no-console
    console.error(error);
  }
};

export const forceMobileView = () => {
  try {
    const viewportMetaElement = getViewportMetaElement();

    viewportMetaElement.setAttribute('content', 'width=device-width,user-scalable=0');
  } catch (error) {
    // tslint:disable-next-line: no-console
    console.error(error);
  }
};
